interface DemoBadgeProps {
  label?: string;
}

export function DemoBadge({ label = '📊 Modo Demonstração' }: DemoBadgeProps) {
  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="bg-blue-500/20 text-blue-400 border border-blue-500/30 px-4 py-2 rounded-lg font-semibold backdrop-blur-sm animate-pulse">
        {label}
      </div>
    </div>
  );
}
